// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5680":"e1cc8d11f635b354","5854":"b07f0062ca7c4bb7","8056":"f4cc025cc63596f2","9501":"d0e1e95572049710"}[chunkId] + ".js";
};